import axios from "axios";
import { loadingAction } from "../redux/actions/loadingAction";
import { toast } from "react-toastify";
import { handleEncryptData } from "./EncryptionService";
import { handleDecryptData } from "./DecryptionService";


export const handlePutRequest = (url, data, isShowload = false, isShowToast = true) => async (dispatch) => {
    const access_token = localStorage.getItem('accessToken')
    try {
        const encryptData = handleEncryptData(data);
        if (isShowload) dispatch(loadingAction(true))
        const response = await axios({
            method: "put",
            url: `${process.env.REACT_APP_BASE_URL_BACKEND + url}`,
            data: encryptData,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${access_token}`
            }
        });
        const decryptedData = handleDecryptData(response?.data?.cipher);

        if (decryptedData?.msg && isShowToast) {
            toast.success(decryptedData?.msg);
        }

        if (isShowload) dispatch(loadingAction(false))
        return {
            status: response?.status,
            data: decryptedData
        };
        // return decryptedData
    } catch (error) {
        const decryptedData = error.response?.data?.cipher
            ? handleDecryptData(error.response.data.cipher)
            : null;
        if (isShowload) dispatch(loadingAction(false));
        if (isShowToast && decryptedData?.msg) {
            toast.warn(decryptedData.msg);
        } else if (isShowToast) {
            toast.error("An unexpected error occurred.");
        }
        error.decryptedData = decryptedData;
        throw error;
        // return decryptedData
    } finally {
        if (isShowload) dispatch(loadingAction(false));
    }
};
